import * as React from "react";
import { IPageProps } from "../interfaces/page-props";
import { RouteComponentProps } from "react-router-dom";
import PageHead from "../components/PageHead";
interface RouteParams {}

const BroadbandCheckPage: React.FC<
  RouteComponentProps<RouteParams> & IPageProps
> = () => {

  return (<div className="content">
        <PageHead
          resellerID=""
          title="Broadband Check Tool"
          parents={[]}
          subpages={[]}
        >
        </PageHead>
        <iframe src="https://www.broadbandchecker.btwholesale.com/#/ADSL/AddressHome" style={{width:'100%',borderStyle:'none',height: '3000px', overflow: 'hidden'}} />
      </div>)
}
export default BroadbandCheckPage;